import React from "react";
import ReactPaginate from "react-paginate";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";

const Pagination = ({ currentPage, totalPages, setPage }) => {
  const changePageNumber = ({ selected }) => {
    setPage(selected);

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!totalPages || totalPages <= 1) {
    return null;
  }

  return (
    <div className="py-4">
      <ReactPaginate
        previousLabel={
          <BsChevronLeft className="w-4 h-4 rtl:rotate-180" />
        }
        nextLabel={
          <BsChevronRight className="w-4 h-4 rtl:rotate-180" />
        }
        breakLabel="..."
        pageCount={totalPages}
        marginPagesDisplayed={1}
        pageRangeDisplayed={3}
        onPageChange={changePageNumber}
        forcePage={currentPage}
        renderOnZeroPageCount={null}

        containerClassName="
          flex flex-wrap items-center justify-center gap-2
          font-kufi
        "

        pageClassName="
          flex items-center justify-center
        "

        pageLinkClassName="
          min-w-[44px] h-11 px-3
          flex items-center justify-center
          rounded-xl
          border border-color-1/15
          bg-white
          text-tcolor-4
          shadow-sm
          cursor-pointer
          transition-all duration-300
          hover:-translate-y-1
          hover:border-color-1/40
          hover:bg-color-1/10
          hover:text-color-1

          dark:bg-back-darktertiary
          dark:border-white/10
          dark:text-gray-300
          dark:hover:bg-color-1/15
          dark:hover:border-color-1/30
          dark:hover:text-color-1
        "

        activeLinkClassName="
          !bg-color-1
          !text-white
          !border-color-1
          shadow-[0_8px_24px_rgba(217,119,6,0.30)]
          scale-105
          pointer-events-none

          dark:!bg-color-1
          dark:!text-white
          dark:!border-color-1
        "

        previousClassName="
          flex items-center justify-center
        "

        nextClassName="
          flex items-center justify-center
        "

        previousLinkClassName="
          w-11 h-11
          flex items-center justify-center
          rounded-xl
          border border-color-1/15
          bg-white
          text-tcolor-4
          shadow-sm
          cursor-pointer
          transition-all duration-300
          hover:-translate-y-1
          hover:bg-color-1
          hover:border-color-1
          hover:text-white

          dark:bg-back-darktertiary
          dark:border-white/10
          dark:text-gray-300
          dark:hover:bg-color-1
          dark:hover:border-color-1
          dark:hover:text-white
        "

        nextLinkClassName="
          w-11 h-11
          flex items-center justify-center
          rounded-xl
          border border-color-1/15
          bg-white
          text-tcolor-4
          shadow-sm
          cursor-pointer
          transition-all duration-300
          hover:-translate-y-1
          hover:bg-color-1
          hover:border-color-1
          hover:text-white

          dark:bg-back-darktertiary
          dark:border-white/10
          dark:text-gray-300
          dark:hover:bg-color-1
          dark:hover:border-color-1
          dark:hover:text-white
        "

        disabledClassName="
          opacity-30
          pointer-events-none
        "

        breakClassName="
          flex items-center justify-center
        "

        breakLinkClassName="
          min-w-[40px] h-11
          flex items-center justify-center
          text-gray-400
          cursor-default
        "
      />
    </div>
  );
};

export default Pagination;